import { createFileRoute, redirect } from "@tanstack/react-router";
import { PerformanceClient } from "@/features/performance/PerformanceClient";

// Beheer → Snelheid: how fast the API answers per route (admin only).
export const Route = createFileRoute("/_shell/performance")({
  beforeLoad: ({ context }) => {
    if (!context.session.roles.includes("admin")) throw redirect({ to: "/dashboard" });
  },
  component: PerformanceScreen,
});

function PerformanceScreen() {
  return (
    <div className="wl-page wl-page--list" data-screen-label="Back-office Performance">
      <PerformanceClient />
    </div>
  );
}
